export const ApiRoutes = {
  RECAPTCHA_SITE_KEY: '/api/recaptcha/site-key',
  RECAPTCHA_VERIFY: '/api/recaptcha/verify',
  CONTACT_SEND: '/api/contact/send',
} as const;

export type ApiRoute = (typeof ApiRoutes)[keyof typeof ApiRoutes];
